module.exports = __webpack_public_path__ + "img/T4-B-rc_1.1cf36f45.png";